<template>
  <div class="content">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="个人训历" name="0">
        <gerenxunLI :userId="userId" v-if="activeName=='0'" :key="sid"></gerenxunLI>
      </el-tab-pane>

      <el-tab-pane label="个人证书" name="1">
        <gerenZS :userId="userId" v-if="activeName=='1'" :key="sid"></gerenZS>
      </el-tab-pane>
      <el-tab-pane label="考试成绩" name="2">
        <gerenKS :userId="userId" v-if="activeName=='2'" :key="sid"></gerenKS>
      </el-tab-pane>

      <el-tab-pane label="个人荣誉" name="3">
        <teacherRY :userId="userId" :key="sid" v-if="activeName==3"></teacherRY>
      </el-tab-pane>

      <el-tab-pane label="个人教历" name="4">
        <gerenJL :userId="userId" v-if="activeName==4" :key="sid"></gerenJL>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { getInfo} from '@/utils/auth';
import * as PersonCenter from '@/api/personcenter/index';
import elSelectc from '@/components/elSelect';
import gerenxunLI from './component/gerenxunLI';
import teacherRY from './component/teacherRY';
import gerenJL from './component/gerenJL';
import gerenKS from './component/gerenKS';
import gerenZS from './component/gerenZS';
export default {
  components: {
    elSelectc,
    gerenxunLI,
    teacherRY,
    gerenJL,
    gerenKS,
    gerenZS,
  },
  data() {
    return {
      sid: +new Date(),
      activeName: '0',
      userId: null,
      tableKey: 0,
      myExamOver: [],
      countRY: 0,
      listQueryExam: {
        page: 1,
        limit: 10,
        userId: null
      },
      countExam: 0,
      socreName:'',
    };
  },
  computed: {
    getinfo() {
      return this.$store.state.User.infos;
    },
  },
  created() {
    if (this.$store.state.User.infos) {
      //判断是否登录，是的或取值，没登录取值会报错
      let list = JSON.parse(getInfo('infos'));
      this.socreName=list.name
      this.listQueryExam.userId=list.id
      this.userId=list.id
    } 
  },
  methods: {
    handleSizeChangeExam(val) {
      this.listQueryExam.limit = val;
      this.getMyExamOver();
    },
    handleCurrentChangeExam(val) {
      this.listQueryExam.page = val;
      this.getMyExamOver();
    },

    // gotocerperson(item) {
    //   this.$router.push({
    //     path: '/certificate/peoplecerticate',
    //     query: {
    //       code: item.code,
    //     },
    //   });
    // },
    //考试
    getMyExamOver() {
      PersonCenter.getMyExamOver(this.listQueryExam).then((res) => {
        this.myExamOver = res.data;
        this.countExam = res.count;
      });
    },

    // 添加人员信息 tab切换
    handleClick(tab, event) {
      console.log(tab.name);
      this.activeName = tab.index;
      if (tab.name == '2') {
       // this.getMyExamOver();
      }
    },
  },
};
</script>
<style scoped>
.content {
  /* width: 900px; */
  width: 100%;
  box-sizing: border-box;
  padding: 20px 10px;
}
.buttons {
  padding: 0 0 20px 20px;
}
.ptable > tr > td {
  text-align: center;
}
.ptable {
  padding: 0;
  margin: 0;
  border: none;
}
.table-bordered {
  border: 1px solid rgb(201, 200, 200);
}
.tableBgc {
  background: #f2f2f2;
}
.pagination {
  margin-top: 20px;
}

/deep/ .el-tabs__item.is-active {
  background-color: #02a7f0;
  color: #fff;
}
</style>